import { proxy } from "valtio";
import { Guidepost } from "@oldDashboard/legacyModels/guidePostReview.model";
import { GuidepostItem } from "@oldDashboard/legacyModels/guidePostItem.model";
import { GuidepostLink } from "@oldDashboard/legacyModels/guidepostLink.model";
interface IGuidepostStore {
	guidepost: Guidepost | null;
	guidepostsList: GuidepostItem[];
	gpReviewModalShow: boolean;
	guidepostLoading: boolean;
	guidepostListLoading: boolean;
	requestEdit: RequestEdit
	approvingGuidepostLoader: boolean;
	guidepostLinks: GuidepostLink[]
}

export type RequestEdit = {
	showModal: boolean;
	showTeamNoteModal: boolean;
	changeGraphicElement: boolean;
	graphicElement: string;
	teamNote: string;
	changeNonGraphicElement: boolean;
	nonGraphicElemet: string;
	changeGuidepostUrl: boolean;
	guidepostUrl: string;
	applyVariations: boolean;
  };
  


class GuidepostStore {
  // Initial state setup
  
	state = proxy<IGuidepostStore>({
		guidepost: null,
		guidepostsList: [],
		gpReviewModalShow: false,
		guidepostLoading: false,
		guidepostListLoading: false,
		guidepostLinks:[],
		approvingGuidepostLoader: false,
		requestEdit: {
			showModal: false,
			showTeamNoteModal: false,
			changeGraphicElement: false,
			graphicElement: "",
			teamNote: "",
			changeNonGraphicElement: false,
			nonGraphicElemet: "",
			changeGuidepostUrl: false,
			guidepostUrl: "",
			applyVariations: false,
			
		},
	})
}

export const guidepostState = proxy(new GuidepostStore());
